import { IS_AFTER_EVENT_TIME } from "@/constants/env"

export const onlineStreamingPageLoader = () => {
  if (IS_AFTER_EVENT_TIME) window.location.href = "/"

  return {}
}
